import React from "react";
import { connect } from "react-redux";
import LeftMenu from "../leftSideComponent/LeftSide";
import Header from "../headerComponent/Header";
import { Link } from "react-router-dom";
import history from "../../auth/history";
class BatchConsumer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            noDue: "unChecked",
            optionalVal: []
        }
    }

    componentDidMount() {
        var val = "";
        var list = [];
        if (this.props.batchConsumers != undefined &&
            this.props.batchConsumers.length > 0) {
            this.props.batchConsumers.map(batch => {
                const map = new Map(Object.entries(batch.optional));
                var mapKeys = [...map.keys()];
                var val = "";
                mapKeys.map(key => {
                    val = val + key + " : " + map.get(key) + ";"
                })
                list.push(batch.id + ">>>" + val);

            })

        }

        this.setState({
            optionalVal: list
        })
    }
    componentWillUnmount() {
    }




    render() {

        return (
            <div>
                <div class="main">
                    <LeftMenu />

                    <div class="right-side">
                        <div class="container-fluid">

                            <Header />
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="dashhead">
                                            <h3>Order List: </h3>
                                            <div class="backbtn">
                                                <Link to='/batch-list'>
                                                    <button type="button" class="back"
                                                    >Back</button>
                                                </Link>

                                            </div>
                                        </div>
                                        {this.props.batchConsumers != undefined &&
                                            this.props.batchConsumers != null &&
                                            this.props.batchConsumers.length > 0 &&
                                            this.props.batchConsumers.map(batch => (
                                                <div class={
                                                    "billist nodue"}>
                                                    {/* //billlkist type=ovrdue */}
                                                    <div class="row">
                                                        <div class="col-12 col-md-3">
                                                            <div class="duetxt csname">
                                                                <h5>{batch.consumerName}</h5>
                                                                <h5>+91-{batch.mobileNo}</h5>
                                                                <h5>ID: {batch.id}</h5>
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-md-5">
                                                            <div class="duetxt">
                                                                <h5>{batch.billerName}</h5>

                                                                {this.state.optionalVal != undefined &&
                                                                    this.state.optionalVal.length > 0 &&

                                                                    this.state.optionalVal.map(key => (
                                                                        key.includes(batch.id) &&
                                                                        <p>{key.split(">>>")[1].replace(";", "").split("_").join(" ")}</p>
                                                                    ))

                                                                }
                                                                {batch.orderId != undefined &&
                                                                    <h5>ORDERID: {batch.orderId}</h5>}
                                                                {batch.batchId != undefined &&
                                                                    <h5>BATCHID: {batch.batchId}</h5>}

                                                            </div>
                                                        </div>


                                                        <div class="col-5 col-md">
                                                            <div class="duetxt">
                                                                <p>Bill Due Date</p>
                                                                <h5>{(batch.lastBillFetch != undefined &&
                                                                    batch.lastBillFetch != null &&
                                                                    batch.lastBillFetch != "" &&
                                                                    batch.lastBillFetch.dueDate != undefined &&
                                                                    batch.lastBillFetch.dueDate != null &&
                                                                    batch.lastBillFetch.dueDate != "") ?
                                                                    batch.lastBillFetch.dueDate : "Unknown"
                                                                }</h5>
                                                            </div>
                                                        </div>
                                                        <div class="col-6 col-md">
                                                            <div class="duetxt text-end">
                                                                <p>Bill Amount</p>
                                                                <h5> {(batch.currentBillPayAmount != undefined &&
                                                                    batch.currentBillPayAmount != null &&
                                                                    batch.currentBillPayAmount != "") ?
                                                                    batch.currentBillPayAmount :
                                                                    (batch.lastPaidBill != undefined &&
                                                                        batch.lastPaidBill != null &&
                                                                        batch.lastPaidBill != "" &&
                                                                        batch.lastPaidBill.lastPaidBillAmount != undefined &&
                                                                        batch.lastPaidBill.lastPaidBillAmount != null &&
                                                                        batch.lastPaidBill.lastPaidBillAmount != "") ?
                                                                        batch.lastPaidBill.lastPaidBillAmount :

                                                                        "NA"}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div class="col-6 col-md">
                                                            <div class="duetxt text-end">
                                                                <p>Status:</p>
                                                                <h5> {batch.lastKnownStatus.split("_").join(" ")}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>))

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>
            </div>



        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, batchConsumers } }
) => ({
    errorMessage, loginErrorMessage, phone, batchConsumers
});

export default connect(mapStateToProps, null)(BatchConsumer);
